import IconInstagram from '@scramble/design-system/icons/social/instagram.svg';
import IconFacebook from '@scramble/design-system/icons/social/facebook.svg';
import IconLinkedIn from '@scramble/design-system/icons/social/linkedin.svg';
import s from './index.module.scss';

const SOCIAL_LINKS = [
  { id: 'instagram', icon: IconInstagram, url: import.meta.env.VITE_INSTAGRAM_LINK || '' },
  { id: 'facebook', icon: IconFacebook, url: import.meta.env.VITE_FACEBOOK_LINK || '' },
  { id: 'linkedin', icon: IconLinkedIn, url: import.meta.env.VITE_LINKEDIN_LINK || '' }
];

export const SocialLinks = () => {
  return (
    <div className={s.wrapper}>
      {SOCIAL_LINKS.map(link => (
        <a key={link.id} href={link.url} target='_blank' rel='noopener noreferrer'>
          <img src={link.icon} alt={link.id} width={20} height={20} />
        </a>
      ))}
    </div>
  );
};